import i18n from '../../i18n'

export const translateVariableName = name => {
  const prefix = 'variable'
  const translation = i18n.t(`${prefix}.${name}`)
  return translation.indexOf(prefix) === 0
    ? name
    : translation
}

export const translateVariableValue = label => {
  if (!label || (/^-?\d*\.?\d*$/).test(label)) {
    return label // label is empty or number
  }
  const prefix = 'variable-label'
  const translation = i18n.t(`${prefix}.${label}`)
  return translation.indexOf(prefix) === 0
    ? label
    : translation
}
